/* Custom Club cart drawer upsell: "+" -> size chips over image -> add (delegated, survives drawer re-renders) */
(function () {
  if (window.__ccuReady) return;
  window.__ccuReady = true;
  var PRE_SHIP = 'Ships in approx. 7 days';

  function add(id, pre, trigger) {
    var cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
    var fd = new FormData();
    fd.append('id', id);
    fd.append('quantity', 1);
    if (pre) fd.append('properties[Pre-order]', PRE_SHIP);
    if (cart && cart.getSectionsToRender) {
      fd.append('sections', cart.getSectionsToRender().map(function (s) { return s.section; }));
      fd.append('sections_url', window.location.pathname);
    }
    trigger.classList.add('is-loading');
    fetch((window.routes && routes.cart_add_url) || '/cart/add', {
      method: 'POST',
      headers: { 'X-Requested-With': 'XMLHttpRequest', 'Accept': 'application/javascript' },
      body: fd
    })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (res.status || res.errors) {
          trigger.classList.remove('is-loading');
          alert(res.description || res.message || 'Could not add to bag.');
          return;
        }
        if (cart && cart.renderContents) {
          cart.renderContents(res);
          if (typeof updateCartCounters === 'function') updateCartCounters();
        } else {
          window.location.href = (window.routes && routes.cart_url) || '/cart';
        }
      })
      .catch(function () { window.location.href = (window.routes && routes.cart_url) || '/cart'; });
  }

  /* Dock: when the "Complete your order" row is out of view, a fixed bar above
     checkout opens the same cards (cloned) without scrolling. */
  var dockOpen = false;
  function syncDock() {
    var dock = document.querySelector('cart-drawer [data-ccu-dock]');
    if (!dock) return;
    var main = document.querySelector('cart-drawer .cart-drawer__main');
    var track = document.querySelector('cart-drawer #ccu-complete .ccu-track');
    // only once there are 2+ different products (gift not counted)
    if (!main || !track || (parseInt(dock.getAttribute('data-lines'), 10) || 0) < 2) { dock.hidden = true; return; }
    var panel = dock.querySelector('[data-ccu-dock-panel]');
    var btn = dock.querySelector('[data-ccu-dock-toggle]');
    var m = main.getBoundingClientRect(), t = track.getBoundingClientRect();
    var inView = t.bottom <= m.bottom + 1 && t.top >= m.top - 1;
    if (inView && !dockOpen) { dock.hidden = true; return; }
    dock.hidden = false;
    dock.classList.toggle('is-open', dockOpen);
    btn.setAttribute('aria-expanded', dockOpen ? 'true' : 'false');
    if (dockOpen && !panel.firstChild) panel.appendChild(track.cloneNode(true));
    if (!dockOpen) panel.innerHTML = '';
  }
  var tmr;
  function queueSync() { clearTimeout(tmr); tmr = setTimeout(syncDock, 30); }
  document.addEventListener('scroll', function (e) {
    if (e.target && e.target.classList && e.target.classList.contains('cart-drawer__main')) queueSync();
  }, true);
  window.addEventListener('resize', queueSync);
  document.addEventListener('DOMContentLoaded', function () {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer) return;
    new MutationObserver(function () {
      var p = drawer.querySelector('[data-ccu-dock-panel]');
      if (!p || !p.firstChild) { queueSync(); setTimeout(queueSync, 450); }
    }).observe(drawer, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] });
    queueSync();
  });

  /* arrows on the upsell rows (cart drawer re-renders, so everything is delegated) */
  function syncArrows() {
    document.querySelectorAll('cart-drawer .ccu-wrap').forEach(function (w) {
      var t = w.querySelector('.ccu-track'), p = w.querySelector('[data-ccu-prev]'), n = w.querySelector('[data-ccu-next]');
      if (!t || !p || !n) return;
      var m = t.querySelector('.ccu-media');
      if (m && m.offsetHeight) w.style.setProperty('--ccu-mid', (m.offsetHeight / 2) + 'px');
      p.hidden = t.scrollLeft < 4;
      n.hidden = t.scrollLeft + t.clientWidth >= t.scrollWidth - 4;
    });
  }
  var atmr;
  function queueArrows() { clearTimeout(atmr); atmr = setTimeout(syncArrows, 40); }
  document.addEventListener('scroll', function (e) {
    if (e.target && e.target.classList && e.target.classList.contains('ccu-track')) queueArrows();
  }, true);
  window.addEventListener('resize', queueArrows);
  document.addEventListener('DOMContentLoaded', function () {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer) return;
    new MutationObserver(function () { queueArrows(); setTimeout(syncArrows, 450); }).observe(drawer, { childList: true, subtree: true, attributes: true, attributeFilter: ['class', 'open'] });
    queueArrows();
  });

  function label(b, open) {
    if (b.classList.contains('ccu-plus')) b.textContent = open ? '×' : '+';
    else b.textContent = open ? 'Select size' : 'Add to cart';
  }

  document.addEventListener('click', function (e) {
    var tog = e.target.closest('[data-ccu-dock-toggle]');
    if (tog) {
      e.preventDefault();
      dockOpen = !dockOpen;
      var p = document.querySelector('cart-drawer [data-ccu-dock-panel]');
      if (p) p.innerHTML = '';
      syncDock();
      return;
    }
    var arr = e.target.closest('[data-ccu-prev], [data-ccu-next]');
    if (arr) {
      e.preventDefault();
      var tr = arr.closest('.ccu-wrap').querySelector('.ccu-track'), c = tr.querySelector('.ccu-card');
      var w = c ? c.getBoundingClientRect().width + 16 : 140;
      tr.scrollBy({ left: arr.hasAttribute('data-ccu-prev') ? -w : w, behavior: 'smooth' });
      return;
    }
    var open = e.target.closest('[data-ccu-open]');
    if (open) {
      e.preventDefault();
      var card = open.closest('.ccu-card');
      var willOpen = !card.classList.contains('is-open');
      document.querySelectorAll('cart-drawer .ccu-card.is-open').forEach(function (c) {
        c.classList.remove('is-open');
        var b = c.querySelector('[data-ccu-open]');
        if (b) { b.classList.remove('is-open'); label(b, false); }
      });
      if (willOpen) {
        card.classList.add('is-open');
        open.classList.add('is-open');
        label(open, true);
      }
      return;
    }
    var btn = e.target.closest('[data-ccu-add]');
    if (btn && !btn.disabled) {
      e.preventDefault();
      add(btn.getAttribute('data-ccu-add'), btn.hasAttribute('data-ccu-pre'), btn);
    }
  });
})();
